// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O-GBM","colMin":"styles_colMin__3Yq5j"};